import "./NavbarHeader.css";
import Logo from "../assests/images/Logo.png";

const NavbarHeader = () => {
  return (
    <>
      <nav className="navbar navbar-expand-lg custom-nav-bar w-100 navbar-light navbar-idea-labs">
        <div className="container-fluid px-5">
          <a className="navbar-brand navbar-brand-idea-labs" href="/">
            {/* <span className="logo-a">a</span>
            <div className="d-flex flex-column">
              <span className="logo-text-top">LABS</span>
              <span className="logo-text-bottom">IDEA</span>
            </div> */}
            <img src={Logo}></img>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavIdeaLabs"
            aria-controls="navbarNavIdeaLabs"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavIdeaLabs">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link nav-link-idea-labs" href="/about-us">
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link nav-link-idea-labs" href="/#ourservices">
                  Services
                </a>
              </li>
              {/* <li className="nav-item">
                <a className="nav-link nav-link-idea-labs" href="/case-studies">
                  Portfolio
                </a>
              </li> */}
              <li className="nav-item">
                <a className="nav-link nav-link-idea-labs" href="/case-studies">
                  Case Studies
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link nav-link-idea-labs" href="/blogs" target="_blank" rel="noreferrer">
                  Blogs
                </a>
              </li>
            </ul>
            <ul className="navbar-nav social-icons-nav ms-auto">
              <li className="nav-item">
                <a rel="noreferrer" target="_blank" href="https://www.facebook.com/anushthan.labs" className="btn">
                <i className="bi bi-facebook btn-social-media"></i>
                </a>
              </li>
              <li className="nav-item">
                <a target="_blank" rel="noreferrer" href="https://www.instagram.com/anushthan.labs/" className="btn">
                  <i className="bi bi-instagram btn-social-media"></i>
                </a>
              </li>
              <li className="nav-item">
                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/anushthan-idea-labs/posts/?feedView=all" className="btn">
                  <i className="bi bi-linkedin btn-social-media"></i>
                </a>
              </li>
              <li className="nav-item">
                <a target="_blank" rel="noreferrer" href="https://www.youtube.com/@AnushthanIdeaLabs" className="btn">
                  <i className="bi bi-youtube btn-social-media"></i>
                </a>
              </li>
              {/* <li className="nav-item ms-lg-3">
                <a href="/#contactus" className="btn btn-let-connect" type="button">
                  Let's Connect
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavbarHeader;
